export const hasNumbersRegExp = /\d{1}/;
